export const ID = 'id';
export const EMAIL = 'email';
export const NAME = 'name';
export const IS_ADMIN = 'is_admin';
export const IS_ACTIVE = 'is_active';
